import {
  ADD_SUB_ORDER_FAIL,
  ADD_SUB_ORDER_REQUEST,
  ADD_SUB_ORDER_SUCCESS,
  DELETE_SUB_ORDER_FAIL,
  DELETE_SUB_ORDER_REQUEST,
  DELETE_SUB_ORDER_SUCCESS,
  GET_SINGLE_SUB_ORDER_FAIL,
  GET_SINGLE_SUB_ORDER_REQUEST,
  GET_SINGLE_SUB_ORDER_SUCCESS,
  GET_SUB_ORDER_LIST_FAIL,
  GET_SUB_ORDER_LIST_REQUEST,
  GET_SUB_ORDER_LIST_SUCCESS,
  UPDATE_SUB_ORDER_FAIL,
  UPDATE_SUB_ORDER_REQUEST,
  UPDATE_SUB_ORDER_SUCCESS,
} from "src/constants/types";

export const subOrderReducers = (state = {}, actions) => {
  switch (actions.type) {
    case GET_SUB_ORDER_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SUB_ORDER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        subOrders: actions.payload,
        error: "",
      };
    case GET_SUB_ORDER_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_SINGLE_SUB_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SINGLE_SUB_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        subOrder: actions.payload,
      };
    case GET_SINGLE_SUB_ORDER_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case ADD_SUB_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case ADD_SUB_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };

    case ADD_SUB_ORDER_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };
    case UPDATE_SUB_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case UPDATE_SUB_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };

    case UPDATE_SUB_ORDER_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case DELETE_SUB_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case DELETE_SUB_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };

    case DELETE_SUB_ORDER_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};
